module.exports = __webpack_public_path__ + "static/media/hilary-duff-lose.e8fc51f0.jpg";